import { Grid, MenuItem } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import InputTextField from '../../../../components/input/inputTextField'
// import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FilterSelect from '../../../../components/select/filterSelect';
import { ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import { SearchOutlined } from '@mui/icons-material';
import { CardOnlineCourses } from '../../online-course/online-courses';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { PublishOnlineCourseApi } from '../../../../api/publish-online-course/publish-online-course.api';

export default function SaveCourse() {
    // const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState<any[]>([{}]);
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, _setPageLimit] = useState<number>(10);
    // const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    // const [sortType, setSortType] = useState<string>("ASC");
    const [type, setType] = useState<any>('ALL')
    const [typeData, setTypeDate] = useState<any>([])

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (type !== 'ALL') condition = { ...condition, id_type: type };
            if (search) condition = { ...condition, keyword: search };
            if (sortBy) condition = { ...condition, sort: sortBy };

            const res = await PublishOnlineCourseApi.my_bookmark(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                // setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, sortBy, search, type]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    return (
        <div>
            <div className="w-full flex justify-end mt-[40px]">
                <Grid container spacing={2} sx={{ justifyContent: 'end' }}>
                    <Grid item xs={12} md={3}>
                        <InputTextField
                            startAdornment={<SearchOutlined />}
                            placeholder={t("ค้นหา")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setSearch(e.target.value)
                            }}
                            value={search || ''}

                        />
                    </Grid>
                    <Grid item xs={12} md={3}>

                        <FilterSelect
                            value={type || ""}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={[{ id_online_course_type: 'ALL', online_course_type: t("ประเภททั้งหมด") }, ...typeData].map((item: any, index: number) => (
                                <MenuItem value={item?.id_online_course_type} key={index + 1}>
                                    {item?.online_course_type}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => { setType(e.target.value) }
                                // handleChangeValueSearch("year", e.target.value)

                            }
                        // style={{
                        //     width:'300px'
                        // }}
                        />
                    </Grid>
                </Grid>
            </div>

            <section className="w-full mt-10">
                <Grid container spacing={2}>
                    {data?.map((item: any, index: number) => {
                        return (
                            <Grid item lg={12 / 6} key={index}>
                                <CardOnlineCourses item={item} getData={loadData} />
                            </Grid>
                        )
                    })}

                </Grid>
            </section>
        </div>
    )
}
